import { Column, Row, Spacer, Text } from "@components/1-atoms";
import ListItem, { ListItemData, Props as ListItemProps, ListSectionHeader } from '@components/2-molecules/ListItem';
import styled, { css } from "@emotion/native";
import React, { FC } from "react";
import { Platform, SectionList as RNSectionList, SectionListRenderItem, View } from "react-native";

import ModuleIcon from '@assets/icons/modules/taxes';
import _ from "underscore";

// Define the shape of our item and section data
interface Item extends ListItemData {
  id: string;
  name: string;
  description?: string;
  rate?: number | string;
}

type Section = { title: string; data: ReadonlyArray<Item> };

const SectionList = styled(RNSectionList<Item, Section>)``;

type Props = ListItemProps & {
  data: any[];
  children?: undefined;
  onPress?: (data: ListItemData) => void;
};

const TaxList: FC<Props> = ({ data, onPress, ...props }) => {

  data = _.chain(data)
    .sortBy((tax) => tax.name)
    .groupBy(_.property(['name', 0]))
    .map((taxes: any, key: string) => ({
      title: `${key}`,
      data: taxes,
    }))
    // .value() unwraps the Underscore object to return the final result.
    .value();

  const _renderItem: SectionListRenderItem<Item, Section> = ({ item }) => {
    let { name, description, rate } = item;

    const right = <Text decimal>{rate}</Text>;

    return (
      <View>
        <ListItem
          sub={description}
          right={right}
          onPress={() => { }}
          {...props}
        >
          {name}
        </ListItem>
        <Spacer h={0.5} />
      </View>
    );
  };



  {/* Empty list message box */ }
  if (data?.length === 0) {
    return (
      <View>
        <Spacer h={3} />
        <Row style={{ justifyContent: 'center' }}>
          <ModuleIcon {...props} />
        </Row>
        <Spacer h={.9} />
        <Row>
          <Column>
            <Text align='center' {...props}>You can manage all your tax items </Text>
            <Text align='center' {...props}>here. Tap <Text bold>+</Text> to create your first </Text>
            <Text align='center' {...props}>tax items.</Text>
          </Column>
        </Row>
        <Spacer h={3} />
      </View>);
  } else {
    return (
      <View>

        {/* CASE 1: */}
        {/* The `AppTemplate` provides a main ScrollView that wraps all the page content. */}
        {/* This ScrollView's job is to allow the entire page content to scroll if its content */}
        {/* is taller than the screen. */}

        {/* This SectionList is itself a scrollable view. */}
        {/* However, nested while not supported in react-native is supported in react-native-web */}

        {/* CASE 2: */}
        {/* The SectionList tries to render with an infinite height, which causes the outer ScrollView */}
        {/* to think its content is infinitely tall. This breaks the layout, often causing the list to expand */}
        {/* and push everything below it off-screen, which is exactly the behavior you were seeing. */}

        {/* WARNINGS ⚠️ : The list has a infinite height when the following styles are removed.  */}
        {/*               The view contains the list inside its immediate container.*/}
        <View style={css(`width: 100%; height: auto; `)}>
          <SectionList
            scrollEnabled={(Platform.OS === 'web') ? true : false}
            sections={data as Section[]}
            keyExtractor={(item) => `${item.id}`}
            renderItem={_renderItem}
            renderSectionHeader={({ section: { title } }) => <ListSectionHeader children={title.toUpperCase()} />}
            renderSectionFooter={(/* { section: { title } } */) => <Spacer h={1} />}
          />
        </View>
      </View>
    );
  };

};

export default TaxList;
